module.exports = __webpack_public_path__ + "img/Saint-Etienne.63a2b2fa.png";